import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntGridContainerComponent} from "./int-grid-container.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntGridContainerComponent
  ],
  exports: [
    IntGridContainerComponent
  ]
})
export class IntGridContainerModule {}
